import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import './App.scss';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import Login from './components/generic/Login';
import MainApp from './components/generic/pages/MainApp';
//import {clearSession } from './storage/sessionStorage';

import "react-datepicker/dist/react-datepicker.css";

class App extends Component {

  render(){
    //clearSession();
    if (!this.props.auth.isSignedIn){
      return <Login/>
    }

    return <MainApp/>
  };
}

const mapStateToProps = (state) => {
  return {
      auth: state.auth
  }
};

export default connect(
  mapStateToProps,
  (dispatch, ownProps) => ({

    }))(App);
